import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { HttpParams } from "@angular/common/http";
import { RateRepository } from "../../../rate/rate.repository";
import { Rate } from "../../../rate/rate-type";
import { rateStatus } from "../../../rate/rate-status.const";
import { Bind } from "primeng/bind";
import { MultiSelect } from "primeng/multiselect";
import { FormsModule } from "@angular/forms";

export interface RateChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-rate-multiselect",
  styleUrls: ["./rate-multiselect.component.scss"],
  templateUrl: "./rate-multiselect.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, MultiSelect, FormsModule],
})
export class RateMultiselectComponent implements OnInit {
  private rateRepository = inject(RateRepository);

  public readonly rateChange = output<Rate[]>();
  @Input() public rates: Rate[];
  public readonly discriminator = input("ltl");
  public readonly disabled = input(false);
  public readonly required = input(false);

  public subscription = new Subscription();
  public rateList: SelectItem[] = [];

  ngOnInit() {
    this.buildRateList();
  }

  public onRateChange(event: Rate[]) {
    this.rateChange.emit(event);
  }

  private buildRateList(): void {
    this.rateList = [];
    let params = new HttpParams();
    params = params.append("criteria[status]", rateStatus.published);
    params = params.append("criteria[valid]", "true");
    const discriminator = this.discriminator();
    if (discriminator) {
      params = params.append("criteria[discriminator]", discriminator);
    }

    this.rateRepository.list(params).subscribe((rateList) => {
      rateList.forEach((rate) => {
        this.rateList.push({ label: rate.getName(), value: rate });
      });
    });
  }
}
